import * as actions from './actions';
import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import SimpleUser from '../../../../../common/types/user/simple-user';
import User from '@common/types/user/user';
import { Action } from 'redux';
import { TracInvite } from '@services/invites/types/trac-invite';
import { UserState } from './state';
import AdditionalAccount from '../../../../../common/types/data/additional-account';

export class GetUser implements LoadingAction {
  readonly type = actions.GET_USER;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class GetUserSuccess implements LoadingAction {
  readonly type = actions.GET_USER_SUCCESS;
  readonly isLoading = false;

  constructor(public user: Partial<User>) {}
}

export class GetUserError implements ErrorAction {
  readonly type = actions.GET_USER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateUser implements LoadingAction {
  readonly type = actions.UPDATE_USER;
  readonly isLoading = true;

  constructor(
    public userData: Partial<User>,
    public onboarding: boolean = false,
    public redirectedFrom?: string
  ) {}
}

export class UpdateUserSuccess implements LoadingAction {
  readonly type = actions.UPDATE_USER_SUCCESS;
  readonly isLoading = false;

  constructor(
    public user: SimpleUser,
    public onboarding: boolean,
    public redirectFrom?: string
  ) {}
}

export class UpdateUserError implements ErrorAction {
  readonly type = actions.UPDATE_USER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class SearchUsers implements LoadingAction {
  readonly type = actions.SEARCH_USERS;
  readonly isLoading = true;

  constructor(public query: string) {}
}

export class SearchUsersSuccess implements LoadingAction {
  readonly type = actions.SEARCH_USERS_SUCCESS;
  readonly isLoading = false;

  constructor(public users: SimpleUser[], public invites: TracInvite[]) {}
}

export class SearchUsersError implements ErrorAction {
  readonly type = actions.SEARCH_USERS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class DeleteUser implements Action {
  readonly type = actions.DELETE_USER;

  constructor(public user: Partial<User>) {}
}

export class DeleteUserSuccess implements LoadingAction {
  readonly type = actions.DELETE_USER_SUCCESS;
  readonly isLoading = false;

  constructor(public user: Partial<User>) {}
}

export class DeleteUserError implements ErrorAction {
  readonly type = actions.DELETE_USER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateAdditionalAccount implements LoadingAction {
  readonly type = actions.CREATE_ADDITIONAL_ACCOUNT;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public password: string) {}
}

export class CreateAdditionalAccountSuccess implements LoadingAction {
  readonly type = actions.CREATE_ADDITIONAL_ACCOUNT_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public account: AdditionalAccount | { attribute: true }) {}
}

export class CreateAdditionalAccountError implements ErrorAction {
  readonly type = actions.CREATE_ADDITIONAL_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class DeleteAdditionalAccount implements LoadingAction {
  readonly type = actions.DELETE_ADDITIONAL_ACCOUNT;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public account: AdditionalAccount) {}
}

export class DeleteAdditionalAccountSuccess implements LoadingAction {
  readonly type = actions.DELETE_ADDITIONAL_ACCOUNT_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public account: AdditionalAccount) {}
}

export class DeleteAdditionalAccountError implements ErrorAction {
  readonly type = actions.DELETE_ADDITIONAL_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ResetUserStore implements Action {
  readonly type = actions.RESET_USER_STORE;
}

export class CheckAdditionalEmails implements Action {
  readonly type = actions.CHECK_ADDITIONAL_EMAILS;

  constructor(public userData: Partial<User>) {}
}

export class AddNewAccount implements Action {
  readonly type = actions.ADD_NEW_ACCOUNT;

  constructor(public account: UserState['newAccount']) {}
}

export class MarkAsVerified implements Action {
  readonly type = actions.MARK_AS_VERIFIED;

  constructor(public address: string) {}
}

export type UserActions =
  | GetUser
  | GetUserSuccess
  | GetUserError
  | UpdateUser
  | UpdateUserSuccess
  | UpdateUserError
  | SearchUsers
  | SearchUsersSuccess
  | SearchUsersError
  | DeleteUser
  | DeleteUserSuccess
  | DeleteUserError
  | CreateAdditionalAccount
  | CreateAdditionalAccountSuccess
  | CreateAdditionalAccountError
  | DeleteAdditionalAccount
  | DeleteAdditionalAccountSuccess
  | DeleteAdditionalAccountError
  | ResetUserStore
  | AddNewAccount
  | MarkAsVerified
  | CheckAdditionalEmails;
